import React from 'react';
import { createRoot } from 'react-dom/client';

import IndexApp from './containers/IndexApp';

import '~/scss/pages/index.scss';

import '~/assets/images/3ia_data_logo.png';

createRoot(document.getElementById('index-app')).render(
    <IndexApp datasets = { DATASETS } />
);
